export enum OrderOptimizerTaxiListingItemStatus {
  PENDING = "PENDING",
  INTERESTING = "INTERESTING",
  REJECTED = "REJECTED",
}

export type OrderOptimizerTaxiListingItemOrder = {
  humanId: number;
  startTime: Date;
  cargoCompany: string;
  haltingTimeBefore: number;
};

export type OrderOptimizerTaxiListingItemRoute = {
  orderHumanId: number;
  lat: number;
  lon: number;
};

export type OrderOptimizerTaxiListingItem = {
  id: string;
  score: number;
  status: OrderOptimizerTaxiListingItemStatus;
  route: OrderOptimizerTaxiListingItemRoute[];
  orders: OrderOptimizerTaxiListingItemOrder[];
  reviewedBy: string | null;
  reviewedAt: Date | null;
};

type OrderOptimizerTaxiListing = {
  data: OrderOptimizerTaxiListingItem[];
  totalCount: number;
};

export default OrderOptimizerTaxiListing;
